import PrimaryCheckbox from '../../../checkbox/Checkbox'

interface CheckboxFilterProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label?: string
  disabled?: boolean
}

function CheckboxFilter({
  checked,
  onChange,
  label,
  disabled,
}: CheckboxFilterProps) {
  function handleChange(
    _event: React.ChangeEvent<HTMLInputElement>,
    newChecked: boolean,
  ) {
    onChange(newChecked)
  }

  return (
    <span style={{ display: 'flex', alignItems: 'center' }}>
      <PrimaryCheckbox
        checked={checked}
        onChange={handleChange}
        label={label}
        disabled={disabled}
        style={{ color: 'var(--filter-border)' }}
      />
    </span>
  )
}

export default CheckboxFilter
